import {
  ASSESSMENT_TEMPLATE_LIST,
  AUDIT_LOGS,
  CHATTER_CLIENT_LIST,
  CHATTER_LESSON_LIST,
  CHATTER_PEER_LIST,
  CHATTER_PROGRAM_LIST,
  CHATTER_TEMPLATE_LIST,
  CLASSROOM_CONSULTATIONS,
  DESIGNATIONS_LIST,
  DISCIPLINES_LIST,
  FUNDING_SOURCE_LIST,
  GOALS_LIST,
  HOME_EDUCATION_LIST,
  MANAGE_CMS_LIST,
  MANAGE_COORDINATORS_LIST,
  MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST,
  MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST,
  MANAGE_NOTIFICATIONS,
  MANAGE_PARENTS_LIST,
  MANAGE_STATUS_LIST,
  MANAGE_SUPPORT_STAFF_LIST,
  MANAGE_TEACHERS_LIST,
  MANAGE_USERS_LIST,
  MDT_ASSESSMENT_LIST,
  MDT_STATUS_LIST,
  MDT_TERMS_LIST,
  NOTES_TABLE,
  NOTIFICATION_TEMPLATES,
  POLICY_AND_PROCEDURE,
  POLICY_AND_PROCEDURE_V2,
  PRIVATE_CLIENT_LIST,
  SCHOOL_BANNERS_LIST,
  SCHOOL_CLIENT_LIST,
  SCHOOL_DIVISON_LIST,
  SCHOOL_LIST,
  SERVICE_STATUS_LIST,
  THERAPIST_LIST,
  WORKSHOPS,
} from "./paths";

const moduleConfig = [
  {
    label: "Management",
    iconKey: "management",
    isDisabled: true,
  },
  {
    label: "Clients",
    iconKey: "clients",
    childLinks: [
      {
        label: "School",
        path: SCHOOL_CLIENT_LIST,
        permission: { module: "client_school", action: "view" },
      },
      {
        label: "Home Education",
        path: HOME_EDUCATION_LIST,
        permission: { module: "client_home", action: "view" },
      },
      {
        label: "Chatter",
        path: CHATTER_CLIENT_LIST,
        permission: { module: "client_chatter", action: "view" },
      },
      {
        label: "Private",
        path: PRIVATE_CLIENT_LIST,
        permission: { module: "client_private", action: "view" },
      },
      {
        label: "Classrooms",
        path: CLASSROOM_CONSULTATIONS,
        permission: { module: "client_discharges", action: "view" },
      },
    ],
  },

  {
    label: "Users",
    iconKey: "users",
    childLinks: [
      {
        label: "Admin",
        path: MANAGE_USERS_LIST,
        permission: { module: "no_access_for_now", action: "view" },
      },
      {
        label: "Clinicians",
        path: THERAPIST_LIST,
        permission: { module: "therapist_profile", action: "view" },
      },
      {
        label: "Parents",
        path: MANAGE_PARENTS_LIST,
        permission: { module: "parent_profile", action: "view" },
      },
      {
        label: "Teachers",
        path: MANAGE_TEACHERS_LIST,
        permission: { module: "teacher_profile", action: "view" },
      },
      {
        label: "Coordinators",
        path: MANAGE_COORDINATORS_LIST,
        permission: { module: "coordinator_profile", action: "view" },
      },
      {
        label: "Support Staff",
        path: MANAGE_SUPPORT_STAFF_LIST,
        permission: { module: "support_staff_profile", action: "view" },
      },
    ],
  },

  {
    label: "Multidisciplinary",
    iconKey: "multidisciplinary",
    childLinks: [
      {
        label: "Multidisciplinary Assessment",
        path: MDT_ASSESSMENT_LIST,
        permission: { module: "mdt_assessment", action: "view" },
      },
      {
        label: "Manage Status",
        path: MDT_STATUS_LIST,
        permission: { module: "mdt_status", action: "view" },
      },
      {
        label: "MDT Terms",
        path: MDT_TERMS_LIST,
        permission: { module: "mdt_term", action: "view" },
      },
    ],
  },

  {
    label: "My Clipboard",
    iconKey: "clipboard",
    childLinks: [
      {
        label: "Workshop",
        path: WORKSHOPS,
        permission: { module: "clipboard_workshops", action: "view" },
      },
      {
        label: "Notes",
        path: NOTES_TABLE,
        permission: { module: "clipboard_notes", action: "view" },
      },
    ],
  },

  {
    label: "Chatter",
    iconKey: "chatter",
    childLinks: [
      {
        label: "Chatter Program Profiles",
        path: CHATTER_PROGRAM_LIST,
        permission: { module: "chatter_program", action: "view" },
      },
      {
        label: "Lesson Plans",
        path: CHATTER_LESSON_LIST,
        permission: { module: "chatter_lesson_plan", action: "view" },
      },
      {
        label: "Chatter Peers",
        path: CHATTER_PEER_LIST,
        permission: { module: "chatter_peer", action: "view" },
      },
      {
        label: "Program Descriptions",
        path: CHATTER_TEMPLATE_LIST,
        permission: { module: "report_template_chatter", action: "view" },
      },
    ],
  },

  {
    label: "Library",
    iconKey: "library",
    childLinks: [
      {
        label: "Assessments",
        path: ASSESSMENT_TEMPLATE_LIST,
        permission: { module: "report_template_assessment", action: "view" },
      },
      {
        label: "Goals",
        path: GOALS_LIST,
        permission: { module: "goals", action: "view" },
      },
      {
        label: "Disciplines",
        path: DISCIPLINES_LIST,
        permission: { module: "discipline_profile", action: "view" },
      },
      {
        label: "School Divisions",
        path: SCHOOL_DIVISON_LIST,
        permission: { module: "school_division", action: "view" },
      },
      {
        label: "Schools",
        path: SCHOOL_LIST,
        permission: { module: "school_profile", action: "view" },
      },
      {
        label: "School Banners",
        path: SCHOOL_BANNERS_LIST,
        permission: { module: "school_banners", action: "view" },
      },
      {
        label: "Designations",
        path: DESIGNATIONS_LIST,
        permission: { module: "designations", action: "view" },
      },
      {
        label: "Funding Sources",
        path: FUNDING_SOURCE_LIST,
        permission: { module: "funding_sources", action: "view" },
      },
      {
        label: "Service Status",
        path: SERVICE_STATUS_LIST,
        permission: { module: "service_status", action: "view" },
      },
      {
        label: "Client Status",
        path: MANAGE_STATUS_LIST,
        permission: { module: "client_status", action: "view" },
      },
    ],
  },
  {
    label: "Policy & Agreements",
    iconKey: "policy_&_agreements",
    childLinks: [
      {
        label: "Policies & Procedures",
        path: POLICY_AND_PROCEDURE_V2 ,
        permission: { module: "policy_and_procedures", action: "view" },
      },
      // {
      //   label: "Policies",
      //   path: POLICY_AND_PROCEDURE,
      //   permission: { module: "policy_and_procedures", action: "view" },
      // },
      {
        label: "Agreements",
        // path: AGREEMENTS_LIST,
        // permission: { module: "agreements", action: "view" },
        isDisabled: true,
      },
      {
        label: "Email",
        path: MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST,
        permission: { module: "email_notification", action: "view" },
      },
      {
        label: "Firebase",
        path: MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST,
        permission: { module: "firebase_notification", action: "view" },
      },
    ]
  },
  {
    label: "Notifications",
    iconKey: "notifications",
    childLinks: [
      {
        label: "Manage Notifications",
        path: MANAGE_NOTIFICATIONS,
        permission: { module: "cms", action: "view" },
      },
      {
        label: "Notification Templates",
        path: NOTIFICATION_TEMPLATES,
        permission: { module: "cms", action: "view" },
      },
    ]
  },
  {
    label: "CMS",
    icon: "cms",
    path: MANAGE_CMS_LIST,
    permission: { module: "cms", action: "view" },
  },
  {
    label: "Audit Logs",
    icon: "audit_logs",
    path: AUDIT_LOGS,
    permission: { module: "audit_logs", action: "view" },
  },

];

export default moduleConfig;
